import { RootState } from '../store'

export const selectNewItems = (state: RootState) => state.sortnew
